import React, { useContext, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Layout from '@/product/components/templates/Layout'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import { currencyFormatWithDecimal } from '@/product/common/components'
import { mapData } from '@/product/common/components'
import ControlHubContext from '@/product/context/controlHub/controlHubContext'
import './MyCards.css'
import { handleRedirectInternal } from '@/product/common/components'
import IconButton from '@mui/material/IconButton'
import authContext from '@/product/context/auth/authContext'
import StripeCardContext from '@/product/context/stripe/card/cardContext'
import StripeCustomerContext from '@/product/context/stripe/customer/customerContext'
import SkyflowCard from '@/product/components/organisms/CardDetails'
import { useFormik } from 'formik'
import AlertContext from '@/product/context/alert/alertContext'
import Loaders from '@/product/components/molecules/Loaders'
import LastMonthInvoice from './LastMonthInvoice'
import './MyPayments.css'
import { dateFormatFront } from '@/product/common/components'
import { Button } from '@mui/material'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import CustomDialog from '@/product/components/organisms/Dialog'

const BillingInfo = (props) => {
    const history = useHistory()
    const alertContext = useContext(AlertContext)
    const [isLoading, setIsLoading] = useState(true)
    const [openPopup, setOpenPopup] = useState(false)
    const [paymentModal, setPaymentModal] = useState(false)
    const controlHubContext = useContext(ControlHubContext)
    const { setAlert } = alertContext
    const [paymentForm, setPaymentForm] = useState(null)
    let type = props.match.params.type
    let paymentID = props.match.params.id
    const {
        get_all_card_details,
        getAllStripeCards,
        responseStatus: responseStatusCard,
        clearResponse: clearResponseCard,
    } = useContext(StripeCardContext)
    const {
        getPendingPayments,
        unpaid_payment,
        payCartStripe,
        responseStatus: responseStatusPayment,
        clearResponse: clearResponsePayment,
    } = controlHubContext
    const [customer, setCustomer] = useState(null)
    const [cards, setCards] = useState([])
    const { user, loadUser, isAuthenticated } = useContext(authContext)
    const [selectedCard, setSelectedCard] = useState({})
    const { customer_details, createStripeCustomer, getStripeCustomer } =
        useContext(StripeCustomerContext)

    const [manageCard, setManageCard] = useState({
        popup: false,
        status: 'new',
        data: null,
    })
    const [managePayment, setManagePayment] = useState({
        popup: false,
        status: 'new',
        data: null,
    })
    const toggleFullScreenCardPopup = (popup, status, data) => {
        if (data === 'lastMonth') {
            setManagePayment({ popup, status, data })
        } else {
            setManageCard({ popup, status, data })
        }
    }

    const getStripeCustomerDetails = () => {
        if (user && user.stripe_id) {
            getStripeCustomer({
                account_id: process.env.REACT_APP_STRIPE_ACCOUNT,
                customer_id: user.stripe_id,
            })
        }
    }

    const getStripeCards = () => {
        if (user && user.stripe_id) {
            getAllStripeCards({
                account_id: process.env.REACT_APP_STRIPE_ACCOUNT,
                customer_id: user.stripe_id,
                object: 'card',
            })
        }
        toggleFullScreenCardPopup(false, 'new', null)
    }

    useEffect(() => {
        if (isAuthenticated) {
            if (user) {
                if (user.admin_id) {
                    if (user.stripe_id) {
                        getStripeCards()
                    } else {
                        createStripeCustomer(
                            {
                                account_id:
                                    process.env.REACT_APP_STRIPE_ACCOUNT,
                                description: 'TEST CUSTOMER',
                                email: user.emp_email,
                                name:
                                    user.emp_firstname +
                                    ' ' +
                                    user.emp_lastname,
                            },
                            false
                        )
                    }
                }
            }
        }
    }, [user, isAuthenticated])

    useEffect(() => {
        if (get_all_card_details) {
            // console.log('!@#get_all_card_details', get_all_card_details)
            setCards(get_all_card_details.records)
        }
        return () => {
            setCards([])
        }
    }, [get_all_card_details])

    useEffect(() => {
        if (customer_details) {
            setCustomer(customer_details)
        }
        return () => {
            setCustomer(null)
        }
    }, [customer_details])

    useEffect(() => {
        if (responseStatusCard) {
            if (
                responseStatusCard.from === 'card_source_create' ||
                responseStatusCard.from === 'card_source_update' ||
                responseStatusCard.from === 'card_source_delete'
            ) {
                if (responseStatusCard.status === 'success') {
                    getStripeCards()
                    setAlert(responseStatusCard.message, 'success')
                } else {
                    setAlert(responseStatusCard.message, 'error')
                }
                clearResponseCard()
            }
            // setIsLoading(false)
        }
    }, [responseStatusCard])
    useEffect(() => {
        if (responseStatusPayment) {
            if (responseStatusPayment.from === 'payment') {
                if (responseStatusPayment.status === 'success') {
                    setAlert(responseStatusPayment.message, 'success')
                    handleRedirectInternal(history, 'billing/paid')
                } else {
                    setAlert(responseStatusPayment.message, 'error')
                }
            }
            setIsLoading(false)
            clearResponsePayment()
        }
    }, [responseStatusPayment])
    useEffect(() => {
        getPendingPayments(
            {
                page: 1,
                limit: 1,
                order: 'asc',
                orderby: 'pay.id',
                filters: {
                    paid: {
                        value: '0',
                        type: 'in',
                        field: 'pay.paid',
                    },
                    id: {
                        value: paymentID > 0 ? paymentID : 0,
                        type: 'in',
                        field: 'pay.id',
                    },
                    plugin_name: {
                        value: type !== 'all' ? type : '',
                        type: 'in',
                        field: 'pay.plugin_name',
                    },
                },
            },
            'MyPayments'
        )
    }, [])
    const paymentformik = useFormik({
        initialValues: {},
        onSubmit: (values) => {
            if (!Object.keys(selectedCard).length) {
                setAlert('Please Select a Card', 'error')
                return false
            } else {
                let formData = {
                    id: paymentForm.id,
                    site_id: paymentForm.site_id,
                    paymentInfo: {
                        source: selectedCard.id,
                        customer: user.stripe_id,
                    },
                    payment_method: 'online',
                    payment_type: 'card',
                    amount: paymentForm.total_amount,
                }
                console.log('formData', formData)
                setIsLoading(true)
                payCartStripe(formData)
            }
        },
    })

    useEffect(() => {
        if (unpaid_payment.from === 'MyPayments') {
            if (unpaid_payment && unpaid_payment.records) {
                if (unpaid_payment.records.length) {
                    const paymentValue = unpaid_payment.records.find((ele) => {
                        if (!ele.paid) {
                            const currentDate = new Date()
                            const dueDate = new Date(ele.due_date)
                            const timeDifferenceMs =
                                dueDate.getTime() - currentDate.getTime()
                            const remainingDays = Math.ceil(
                                timeDifferenceMs / (1000 * 3600 * 24)
                            )
                            if (remainingDays > 0) {
                                ele.remainingDays = remainingDays

                                return ele
                            } else if (remainingDays === 0) {
                                ele.remainingDays = 0
                                return ele
                            } else {
                                ele.remainingDays = 0
                                return ele
                            }
                        }
                    })

                    setPaymentForm(
                        paymentValue !== 'undefined' && paymentValue !== null
                            ? paymentValue
                            : null
                    )

                    setIsLoading(false)
                } else {
                    setIsLoading(false)
                }
            } else {
                setPaymentForm(null)
            }
        }
    }, [unpaid_payment])

    const selectCardFn = (card) => {
        setSelectedCard({ ...card })
    }
    const openLastInvoice = () => {
        toggleFullScreenCardPopup(true, 'new', 'lastMonth')
    }

    const handlePaymentModal = () => {
        setPaymentModal(!paymentModal)
    }

    return (
        <>
            <Layout>
                {isLoading ? (
                    <Loaders isLoading={isLoading} />
                ) : (
                    <>
                        <div className="viewLastInvoice">
                            <Button
                                id="last_invoice"
                                variant="outlined"
                                btnSize="small"
                                onClick={() => openLastInvoice()}
                            >
                                <span className="material-icons">
                                    visibility
                                </span>
                                View Last Invoice
                            </Button>
                        </div>
                        {paymentForm && user?.stripe_id ? (
                            <>
                                {paymentForm && (
                                    <div className="billingDetItem">
                                        {console.log(
                                            paymentForm,
                                            'paymentForm'
                                        )}

                                        <div className="billingDetInner">
                                            {paymentForm.remainingDays > 0 ? (
                                                <span className="dueOn">
                                                    {`Due on ${dateFormatFront(
                                                        paymentForm?.due_date
                                                    )}`}
                                                </span>
                                            ) : (
                                                <span className="dueOn">{`Payment is due today`}</span>
                                            )}
                                            <div>
                                                {' '}
                                                <h4 className="bdTitle">
                                                    {paymentForm.title}
                                                </h4>
                                                <h5 className="bdDesc">
                                                    {paymentForm.description}
                                                </h5>
                                            </div>
                                        </div>

                                        <div className="billingPayable">
                                            <h5>
                                                Total amount due:{' '}
                                                <span>
                                                    {' '}
                                                    {currencyFormatWithDecimal(
                                                        paymentForm.total_amount
                                                    )}
                                                </span>
                                            </h5>

                                            {paymentForm?.external_link ? (
                                                <PrimaryButton
                                                    btnSize="small"
                                                    onClick={() =>
                                                        window.open(
                                                            `${paymentForm.external_link}`,
                                                            '_blank',
                                                            'noopener,noreferrer'
                                                        )
                                                    }
                                                    label="Make Payment"
                                                    iconLeft={
                                                        <span className="material-icons">
                                                            open_in_new
                                                        </span>
                                                    }
                                                />
                                            ) : (
                                                <PrimaryButton
                                                    btnSize="small"
                                                    onClick={() =>
                                                        setPaymentModal(true)
                                                    }
                                                    label="Make Payment"
                                                />
                                            )}
                                        </div>
                                    </div>
                                )}
                            </>
                        ) : (
                            <h4>No Pending Payments</h4>
                        )}
                    </>
                )}
                <LastMonthInvoice
                    data={managePayment}
                    function={toggleFullScreenCardPopup}
                />
                <CustomDialog
                    className="makePaymentModal"
                    title="Review Payment Details"
                    open={paymentModal}
                    closeBtn={() => setPaymentModal(false)}
                    function={handlePaymentModal}
                >
                    <div>
                        {paymentForm &&
                        user?.stripe_id &&
                        paymentForm?.paymentList?.length > 0 ? (
                            <div className="mpmTable table-responsive">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Name</th>
                                            <th>Amount</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {paymentForm?.paymentList?.map(
                                            (data, index) => (
                                                <tr key={index}>
                                                    <td>{data.name}</td>
                                                    <td>
                                                        {currencyFormatWithDecimal(
                                                            data.amount
                                                        )}
                                                    </td>
                                                </tr>
                                            )
                                        )}
                                        {paymentForm?.tax_percentage &&
                                        paymentForm?.tax_amount ? (
                                            <>
                                                <tr>
                                                    <td>
                                                        {` Total Tax Amount (${paymentForm?.tax_percentage}%)`}{' '}
                                                    </td>
                                                    <td>
                                                        {currencyFormatWithDecimal(
                                                            paymentForm?.tax_amount
                                                        )}
                                                    </td>
                                                </tr>
                                            </>
                                        ) : null}
                                        {paymentForm?.card_fee_percentage &&
                                        paymentForm?.card_fee ? (
                                            <>
                                                <tr>
                                                    <td>
                                                        {` Credit Card Fee (${paymentForm.card_fee_percentage}%)`}{' '}
                                                    </td>
                                                    <td>
                                                        {currencyFormatWithDecimal(
                                                            paymentForm.card_fee
                                                        )}
                                                    </td>
                                                </tr>
                                            </>
                                        ) : null}
                                    </tbody>
                                </table>
                                <div className="mpmTablePayableAmt">
                                    <h6>Total Payable:</h6>
                                    <span>
                                        {currencyFormatWithDecimal(
                                            paymentForm?.total_amount
                                        )}
                                    </span>
                                </div>
                            </div>
                        ) : null}

                        <h6 className="mpmTitle">
                            Select a Card
                            <span className="material-icons">credit_card</span>
                        </h6>

                        <div className="savedCardsPayment">
                            <div
                                className="cardRadio newCard"
                                onClick={() =>
                                    toggleFullScreenCardPopup(true, 'new', null)
                                }
                            >
                                Add a new Card{' '}
                                <span className="material-icons">add</span>
                            </div>

                            {cards.length > 0
                                ? cards.map((card) => {
                                      return (
                                          <div
                                              className={`cardRadio ${
                                                  card.id === selectedCard?.id
                                                      ? 'active'
                                                      : ''
                                              }`}
                                              onClick={() => selectCardFn(card)}
                                          >
                                              <div>
                                                  <label>
                                                      <span>{card.brand}</span>
                                                      <span className="cardDivider">
                                                          |
                                                      </span>
                                                      <span>
                                                          Expires{' '}
                                                          {card.exp_month} /{' '}
                                                          {card.exp_year}
                                                      </span>
                                                  </label>
                                                  <p>
                                                      <span>****</span>
                                                      <span>****</span>
                                                      <span>****</span>
                                                      <span>{card.last4}</span>
                                                  </p>
                                              </div>
                                              <div className="sc-btns-wrap d-flex align-items-center justify-content-between">
                                                  <IconButton
                                                      id="card_edit"
                                                      className="edtBtn"
                                                      onClick={() =>
                                                          toggleFullScreenCardPopup(
                                                              true,
                                                              'update',
                                                              card
                                                          )
                                                      }
                                                  >
                                                      <span className="material-icons">
                                                          edit
                                                      </span>
                                                  </IconButton>
                                                  {cards.length > 1 && (
                                                      <>
                                                          {user &&
                                                              user.stripe_id && (
                                                                  <>
                                                                      {/* <IconButton
                                                                          className="defaultBtn"
                                                                          onClick={() =>
                                                                              toggleFullScreenCardPopup(
                                                                                  true,
                                                                                  'default',
                                                                                  card
                                                                              )
                                                                          }
                                                                      >
                                                                          <span className="material-icons">
                                                                              check_circle
                                                                          </span>
                                                                      </IconButton> */}

                                                                      <IconButton
                                                                          className="dltBtn"
                                                                          id="card_delete"
                                                                          onClick={() =>
                                                                              toggleFullScreenCardPopup(
                                                                                  true,
                                                                                  'delete',
                                                                                  card
                                                                              )
                                                                          }
                                                                      >
                                                                          <span className="material-icons">
                                                                              delete
                                                                          </span>
                                                                      </IconButton>
                                                                  </>
                                                              )}
                                                      </>
                                                  )}
                                              </div>
                                              {card.id === selectedCard?.id ? (
                                                  <span className="material-icons">
                                                      radio_button_checked
                                                  </span>
                                              ) : (
                                                  <span className="material-icons">
                                                      radio_button_unchecked
                                                  </span>
                                              )}
                                          </div>
                                      )
                                  })
                                : ''}
                        </div>

                        <form
                            onSubmit={paymentformik.handleSubmit}
                            autoComplete="nofill"
                            className="mpmAction"
                        >
                            <PrimaryButton
                                id="inventory_update"
                                type="submit"
                                label="Make Payment"
                                disabled={isLoading}
                            />
                        </form>
                    </div>
                </CustomDialog>
                <SkyflowCard
                    allCards={cards}
                    data={manageCard}
                    card_cvv={true}
                    function={toggleFullScreenCardPopup}
                />
            </Layout>
        </>
    )
}

export default BillingInfo
